import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface MarkdownContentProps {
  content: string;
  className?: string;
}

export const MarkdownContent = ({ content, className }: MarkdownContentProps) => (
  <div className={`text-sm max-w-none [&>*:first-child]:mt-0 [&>*:last-child]:mb-0 ${className ?? ""}`}>
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        h1: ({ children }) => <h3 className="text-sm font-bold mt-2 mb-1 text-genie-text-primary">{children}</h3>,
        h2: ({ children }) => <h3 className="text-sm font-bold mt-2 mb-1 text-genie-text-primary">{children}</h3>,
        h3: ({ children }) => <h4 className="text-sm font-semibold mt-1.5 mb-0.5 text-genie-text-primary">{children}</h4>,
        p: ({ children }) => <p className="mb-1.5 leading-relaxed last:mb-0">{children}</p>,
        ul: ({ children }) => <ul className="mb-1.5 pl-4 space-y-0.5 list-disc last:mb-0">{children}</ul>,
        ol: ({ children }) => <ol className="mb-1.5 pl-4 space-y-0.5 list-decimal last:mb-0">{children}</ol>,
        li: ({ children }) => <li>{children}</li>,
        strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
        em: ({ children }) => <em className="italic">{children}</em>,
        hr: () => <hr className="my-2 border-genie-border" />,
        code: ({ children }) => (
          <code className="bg-black/5 px-1 py-0.5 rounded text-xs font-mono">{children}</code>
        ),
        pre: ({ children }) => (
          <pre className="bg-black/5 p-2 rounded overflow-x-auto mb-1.5 text-xs">{children}</pre>
        ),
        blockquote: ({ children }) => (
          <blockquote className="border-l-2 border-genie-border pl-2 italic text-genie-text-secondary mb-1.5">
            {children}
          </blockquote>
        ),
        table: ({ children }) => <table className="text-xs border-collapse w-full mb-1.5">{children}</table>,
        th: ({ children }) => (
          <th className="border border-genie-border px-2 py-1 bg-genie-background-muted font-semibold text-left">
            {children}
          </th>
        ),
        td: ({ children }) => <td className="border border-genie-border px-2 py-1">{children}</td>,
        a: ({ children, href }) => (
          <a href={href} target="_blank" rel="noopener noreferrer" className="text-genie-primary underline">
            {children}
          </a>
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  </div>
);
